export const customFieldTypes = {
	String: 'String',
	Number: 'Number',
	DateTime: 'DateTime',
	Boolean: 'Boolean',
	Phone: 'Phone',
};
